import {Component,Injector,OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Store} from '@ngrx/store';

import {AppState} from '@domain/appstate';
import {Session} from '@domain/security/session';
import {LayoutService} from '@share/layout/layout.service';
import * as moment from "moment-timezone";
import {LoginService} from "@share/login/login.service";
import {TranslateService} from "@ngx-translate/core";

/**
 * Composant principal
 */
@Component({
    selector: 'body',
    template: '<layout></layout>',
    host: {
        '[class.full-width]': '!session?.isLogged || session?.isAdmin || session?.isPasswordExpired'
    }
})
export class AppComponent implements OnInit {
    /** Session de l'utilisateur connecté */
    session: Session = null;

    /** Injecteur Angular */
    private static injector: Injector;

    /**
     * Constructeur par défaut
     */
    constructor(public router: Router,
                private store: Store<AppState>,
                private layoutService: LayoutService,
                private loginService: LoginService,
                injector: Injector) {
        //Mémorisation de l'injector
        AppComponent.injector = injector;

        //Définition de la timezone MomentJS
        moment.tz.setDefault('Europe/Paris');
    }

    /**
     * Initialisation
     */
    async ngOnInit() {
        //Attente du chargement du mode d'authentification (normalement il a déjà été chargé lors du login)
        await this.loginService.loadAuth().toPromise();

        //Sélection de la session
        this.store.select<Session>(s => s.session).subscribe(session => {
            //Mémorisation de la session
            this.session = session;

            //Initialisation du layout
            this.layoutService.init(session);
        });
    }

    /**
     * Méthode statique de traduction pour les composants où l'injecteur Angular n'est pas disponible
     *
     * @param key Clef de traduction
     * @param params Paramètres de traduction
     */
    static translate(key: string,params?: object): string {
        //Récupération du service de traduction
        const translateService = AppComponent.injector?.get(TranslateService);

        //Retour de la traduction
        return translateService?.instant(key,params) ?? key;
    }
}
